module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.isSelected
    }
  }, [(_vm.price.on_request === 0) ? _c('div', {
    staticClass: "uk-grid-collapse tm-price",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-expand",
    attrs: {
      "uk-leader": ""
    }
  }, [_vm._v("\n            от " + _vm._s(_vm.price.price_break) + " шт.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-price-value"
  }, [_vm._v("\n            " + _vm._s(_vm.price.calculated_price) + " " + _vm._s(_vm.currency.name) + "\n        ")])]) : _c('div', {
    staticClass: "uk-grid-collapse tm-price",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-expand",
    attrs: {
      "uk-leader": ""
    }
  }, [_vm._v("\n            от " + _vm._s(_vm.price.price_break) + " шт.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-price-value"
  }, [_vm._v("\n            Цена по запросу\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dad9175","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Product/ProductPriceRow.vue
// module id = 38
// module chunks = 0